"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.function.name.js");
function cov_9w9avct5g() {
  var path = "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/config/lib/model.js";
  var hash = "177c8a90badc0ec87c4e66452bb47f9eda960a7f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/config/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 18
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 14,
          column: 6
        }
      },
      "2": {
        start: {
          line: 4,
          column: 22
        },
        end: {
          line: 4,
          column: 33
        }
      },
      "3": {
        start: {
          line: 5,
          column: 6
        },
        end: {
          line: 5,
          column: 37
        }
      },
      "4": {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 9,
          column: 42
        }
      },
      "5": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 35
        }
      },
      "6": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 12,
          column: 98
        }
      },
      "7": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 21
        }
      },
      "8": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "9": {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 17,
          column: 33
        }
      },
      "10": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 21,
          column: 42
        }
      },
      "11": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 25,
          column: 41
        }
      },
      "12": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 21
        }
      },
      "13": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 139,
          column: 1
        }
      },
      "14": {
        start: {
          line: 32,
          column: 21
        },
        end: {
          line: 32,
          column: 79
        }
      },
      "15": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 36,
          column: 47
        }
      },
      "16": {
        start: {
          line: 37,
          column: 19
        },
        end: {
          line: 37,
          column: 73
        }
      },
      "17": {
        start: {
          line: 38,
          column: 20
        },
        end: {
          line: 38,
          column: 76
        }
      },
      "18": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 91
        }
      },
      "19": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 49,
          column: 10
        }
      },
      "20": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 56,
          column: 58
        }
      },
      "21": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      },
      "22": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 63,
          column: 8
        }
      },
      "23": {
        start: {
          line: 65,
          column: 26
        },
        end: {
          line: 65,
          column: 57
        }
      },
      "24": {
        start: {
          line: 66,
          column: 23
        },
        end: {
          line: 66,
          column: 95
        }
      },
      "25": {
        start: {
          line: 67,
          column: 26
        },
        end: {
          line: 67,
          column: 104
        }
      },
      "26": {
        start: {
          line: 68,
          column: 23
        },
        end: {
          line: 68,
          column: 52
        }
      },
      "27": {
        start: {
          line: 70,
          column: 18
        },
        end: {
          line: 70,
          column: 70
        }
      },
      "28": {
        start: {
          line: 71,
          column: 20
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "29": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "30": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 50
        }
      },
      "31": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 90
        }
      },
      "32": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 96,
          column: 6
        }
      },
      "33": {
        start: {
          line: 99,
          column: 20
        },
        end: {
          line: 99,
          column: 48
        }
      },
      "34": {
        start: {
          line: 100,
          column: 18
        },
        end: {
          line: 100,
          column: 59
        }
      },
      "35": {
        start: {
          line: 101,
          column: 20
        },
        end: {
          line: 101,
          column: 48
        }
      },
      "36": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 30
        }
      },
      "37": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "38": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 38
        }
      },
      "39": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 110,
          column: 6
        }
      },
      "40": {
        start: {
          line: 113,
          column: 22
        },
        end: {
          line: 115,
          column: 5
        }
      },
      "41": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 126,
          column: 5
        }
      },
      "42": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 125,
          column: 8
        }
      },
      "43": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 132,
          column: 5
        }
      },
      "44": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 131,
          column: 8
        }
      },
      "45": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 137,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 7
          },
          end: {
            line: 2,
            column: 8
          }
        },
        loc: {
          start: {
            line: 3,
            column: 4
          },
          end: {
            line: 14,
            column: 6
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 3,
            column: 20
          },
          end: {
            line: 3,
            column: 21
          }
        },
        loc: {
          start: {
            line: 3,
            column: 28
          },
          end: {
            line: 14,
            column: 5
          }
        },
        line: 3
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 15,
            column: 18
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 27,
            column: 6
          }
        },
        line: 16
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 16,
            column: 20
          },
          end: {
            line: 16,
            column: 21
          }
        },
        loc: {
          start: {
            line: 16,
            column: 28
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 16
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 31,
            column: 7
          },
          end: {
            line: 31,
            column: 8
          }
        },
        loc: {
          start: {
            line: 31,
            column: 27
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 31
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 98,
            column: 20
          },
          end: {
            line: 98,
            column: 21
          }
        },
        loc: {
          start: {
            line: 98,
            column: 40
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 98
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 112,
            column: 18
          },
          end: {
            line: 112,
            column: 19
          }
        },
        loc: {
          start: {
            line: 112,
            column: 57
          },
          end: {
            line: 138,
            column: 3
          }
        },
        line: 112
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 8
          },
          end: {
            line: 9,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 8
          },
          end: {
            line: 7,
            column: 30
          }
        }, {
          start: {
            line: 8,
            column: 8
          },
          end: {
            line: 8,
            column: 37
          }
        }, {
          start: {
            line: 9,
            column: 8
          },
          end: {
            line: 9,
            column: 41
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 29
          }
        }, {
          start: {
            line: 12,
            column: 33
          },
          end: {
            line: 12,
            column: 61
          }
        }, {
          start: {
            line: 12,
            column: 65
          },
          end: {
            line: 12,
            column: 97
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 21,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 19,
            column: 33
          }
        }, {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 21,
            column: 8
          },
          end: {
            line: 21,
            column: 41
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 25,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 32
          }
        }, {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 24,
            column: 39
          }
        }, {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 40
          }
        }],
        line: 23
      },
      "4": {
        loc: {
          start: {
            line: 32,
            column: 21
          },
          end: {
            line: 32,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 22
          },
          end: {
            line: 32,
            column: 26
          }
        }, {
          start: {
            line: 32,
            column: 30
          },
          end: {
            line: 32,
            column: 43
          }
        }, {
          start: {
            line: 32,
            column: 49
          },
          end: {
            line: 32,
            column: 57
          }
        }, {
          start: {
            line: 32,
            column: 61
          },
          end: {
            line: 32,
            column: 78
          }
        }],
        line: 32
      },
      "5": {
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 7
          },
          end: {
            line: 34,
            column: 11
          }
        }, {
          start: {
            line: 34,
            column: 15
          },
          end: {
            line: 34,
            column: 28
          }
        }, {
          start: {
            line: 35,
            column: 7
          },
          end: {
            line: 35,
            column: 15
          }
        }, {
          start: {
            line: 35,
            column: 19
          },
          end: {
            line: 35,
            column: 36
          }
        }, {
          start: {
            line: 36,
            column: 7
          },
          end: {
            line: 36,
            column: 11
          }
        }, {
          start: {
            line: 36,
            column: 15
          },
          end: {
            line: 36,
            column: 46
          }
        }],
        line: 34
      },
      "6": {
        loc: {
          start: {
            line: 37,
            column: 19
          },
          end: {
            line: 37,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 20
          },
          end: {
            line: 37,
            column: 24
          }
        }, {
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 39
          }
        }, {
          start: {
            line: 37,
            column: 45
          },
          end: {
            line: 37,
            column: 53
          }
        }, {
          start: {
            line: 37,
            column: 57
          },
          end: {
            line: 37,
            column: 72
          }
        }],
        line: 37
      },
      "7": {
        loc: {
          start: {
            line: 38,
            column: 20
          },
          end: {
            line: 38,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 21
          },
          end: {
            line: 38,
            column: 25
          }
        }, {
          start: {
            line: 38,
            column: 29
          },
          end: {
            line: 38,
            column: 41
          }
        }, {
          start: {
            line: 38,
            column: 47
          },
          end: {
            line: 38,
            column: 55
          }
        }, {
          start: {
            line: 38,
            column: 59
          },
          end: {
            line: 38,
            column: 75
          }
        }],
        line: 38
      },
      "8": {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 7
          },
          end: {
            line: 41,
            column: 11
          }
        }, {
          start: {
            line: 41,
            column: 16
          },
          end: {
            line: 41,
            column: 34
          }
        }, {
          start: {
            line: 41,
            column: 38
          },
          end: {
            line: 41,
            column: 49
          }
        }, {
          start: {
            line: 41,
            column: 56
          },
          end: {
            line: 41,
            column: 64
          }
        }, {
          start: {
            line: 41,
            column: 68
          },
          end: {
            line: 41,
            column: 90
          }
        }],
        line: 41
      },
      "9": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 49,
            column: 10
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 7
          },
          end: {
            line: 46,
            column: 20
          }
        }, {
          start: {
            line: 46,
            column: 24
          },
          end: {
            line: 46,
            column: 57
          }
        }, {
          start: {
            line: 47,
            column: 7
          },
          end: {
            line: 47,
            column: 20
          }
        }, {
          start: {
            line: 47,
            column: 24
          },
          end: {
            line: 47,
            column: 57
          }
        }, {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 30
          }
        }, {
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 49,
            column: 10
          }
        }],
        line: 46
      },
      "10": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 56,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 7
          },
          end: {
            line: 53,
            column: 11
          }
        }, {
          start: {
            line: 53,
            column: 15
          },
          end: {
            line: 53,
            column: 28
          }
        }, {
          start: {
            line: 54,
            column: 7
          },
          end: {
            line: 54,
            column: 15
          }
        }, {
          start: {
            line: 54,
            column: 19
          },
          end: {
            line: 54,
            column: 36
          }
        }, {
          start: {
            line: 55,
            column: 7
          },
          end: {
            line: 55,
            column: 20
          }
        }, {
          start: {
            line: 55,
            column: 24
          },
          end: {
            line: 55,
            column: 53
          }
        }, {
          start: {
            line: 56,
            column: 7
          },
          end: {
            line: 56,
            column: 20
          }
        }, {
          start: {
            line: 56,
            column: 24
          },
          end: {
            line: 56,
            column: 57
          }
        }],
        line: 53
      },
      "11": {
        loc: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 58
      },
      "12": {
        loc: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 21
          }
        }, {
          start: {
            line: 58,
            column: 25
          },
          end: {
            line: 58,
            column: 50
          }
        }, {
          start: {
            line: 58,
            column: 54
          },
          end: {
            line: 58,
            column: 90
          }
        }],
        line: 58
      },
      "13": {
        loc: {
          start: {
            line: 65,
            column: 26
          },
          end: {
            line: 65,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 26
          },
          end: {
            line: 65,
            column: 34
          }
        }, {
          start: {
            line: 65,
            column: 38
          },
          end: {
            line: 65,
            column: 57
          }
        }],
        line: 65
      },
      "14": {
        loc: {
          start: {
            line: 66,
            column: 23
          },
          end: {
            line: 66,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 24
          },
          end: {
            line: 66,
            column: 28
          }
        }, {
          start: {
            line: 66,
            column: 32
          },
          end: {
            line: 66,
            column: 47
          }
        }, {
          start: {
            line: 66,
            column: 53
          },
          end: {
            line: 66,
            column: 66
          }
        }, {
          start: {
            line: 66,
            column: 70
          },
          end: {
            line: 66,
            column: 94
          }
        }],
        line: 66
      },
      "15": {
        loc: {
          start: {
            line: 67,
            column: 26
          },
          end: {
            line: 67,
            column: 104
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 27
          },
          end: {
            line: 67,
            column: 31
          }
        }, {
          start: {
            line: 67,
            column: 35
          },
          end: {
            line: 67,
            column: 53
          }
        }, {
          start: {
            line: 67,
            column: 59
          },
          end: {
            line: 67,
            column: 72
          }
        }, {
          start: {
            line: 67,
            column: 76
          },
          end: {
            line: 67,
            column: 103
          }
        }],
        line: 67
      },
      "16": {
        loc: {
          start: {
            line: 70,
            column: 18
          },
          end: {
            line: 70,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 19
          },
          end: {
            line: 70,
            column: 23
          }
        }, {
          start: {
            line: 70,
            column: 27
          },
          end: {
            line: 70,
            column: 37
          }
        }, {
          start: {
            line: 70,
            column: 43
          },
          end: {
            line: 70,
            column: 51
          }
        }, {
          start: {
            line: 70,
            column: 55
          },
          end: {
            line: 70,
            column: 69
          }
        }],
        line: 70
      },
      "17": {
        loc: {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 78
      },
      "18": {
        loc: {
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 15
          }
        }, {
          start: {
            line: 78,
            column: 19
          },
          end: {
            line: 78,
            column: 36
          }
        }],
        line: 78
      },
      "19": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 7
          },
          end: {
            line: 82,
            column: 20
          }
        }, {
          start: {
            line: 82,
            column: 24
          },
          end: {
            line: 82,
            column: 50
          }
        }, {
          start: {
            line: 82,
            column: 56
          },
          end: {
            line: 82,
            column: 64
          }
        }, {
          start: {
            line: 82,
            column: 68
          },
          end: {
            line: 82,
            column: 89
          }
        }],
        line: 82
      },
      "20": {
        loc: {
          start: {
            line: 99,
            column: 20
          },
          end: {
            line: 99,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 20
          },
          end: {
            line: 99,
            column: 28
          }
        }, {
          start: {
            line: 99,
            column: 32
          },
          end: {
            line: 99,
            column: 48
          }
        }],
        line: 99
      },
      "21": {
        loc: {
          start: {
            line: 100,
            column: 18
          },
          end: {
            line: 100,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 19
          },
          end: {
            line: 100,
            column: 23
          }
        }, {
          start: {
            line: 100,
            column: 27
          },
          end: {
            line: 100,
            column: 37
          }
        }, {
          start: {
            line: 100,
            column: 42
          },
          end: {
            line: 100,
            column: 59
          }
        }],
        line: 100
      },
      "22": {
        loc: {
          start: {
            line: 101,
            column: 20
          },
          end: {
            line: 101,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 20
          },
          end: {
            line: 101,
            column: 28
          }
        }, {
          start: {
            line: 101,
            column: 32
          },
          end: {
            line: 101,
            column: 48
          }
        }],
        line: 101
      },
      "23": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 103
      },
      "24": {
        loc: {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 103,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 103,
            column: 15
          }
        }, {
          start: {
            line: 103,
            column: 19
          },
          end: {
            line: 103,
            column: 24
          }
        }],
        line: 103
      },
      "25": {
        loc: {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 126,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 116
      },
      "26": {
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 119,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 117,
            column: 29
          }
        }, {
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 118,
            column: 41
          }
        }, {
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 119,
            column: 52
          }
        }],
        line: 117
      },
      "27": {
        loc: {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 127
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0],
      "2": [0, 0, 0],
      "3": [0, 0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0, 0, 0, 0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0, 0, 0, 0],
      "9": [0, 0, 0, 0, 0, 0],
      "10": [0, 0, 0, 0, 0, 0, 0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0, 0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0, 0],
      "20": [0, 0],
      "21": [0, 0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0, 0],
      "27": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "177c8a90badc0ec87c4e66452bb47f9eda960a7f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_9w9avct5g = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_9w9avct5g();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var LinkModel = (cov_9w9avct5g().s[0]++, {
  get: function get(customLinks, language, defaultLanguage) {
    cov_9w9avct5g().f[0]++;
    cov_9w9avct5g().s[1]++;
    return customLinks.map(function (link) {
      cov_9w9avct5g().f[1]++;
      var linkTmp = (cov_9w9avct5g().s[2]++, _objectSpread({}, link));
      cov_9w9avct5g().s[3]++;
      linkTmp.rawName = linkTmp.name;
      cov_9w9avct5g().s[4]++;
      linkTmp.name = (cov_9w9avct5g().b[0][0]++, linkTmp.name[language]) || (cov_9w9avct5g().b[0][1]++, linkTmp.name[defaultLanguage]) || (cov_9w9avct5g().b[0][2]++, (0, _values.default)(linkTmp.rawName)[0]);
      cov_9w9avct5g().s[5]++;
      linkTmp.rawUrl = linkTmp.url;
      cov_9w9avct5g().s[6]++;
      linkTmp.url = (cov_9w9avct5g().b[1][0]++, linkTmp.url[language]) || (cov_9w9avct5g().b[1][1]++, linkTmp.url[defaultLanguage]) || (cov_9w9avct5g().b[1][2]++, (0, _values.default)(linkTmp.rawUrl)[0]);
      cov_9w9avct5g().s[7]++;
      return linkTmp;
    });
  },
  changeLanguage: function changeLanguage(customLinks, language, defaultLanguage) {
    cov_9w9avct5g().f[2]++;
    cov_9w9avct5g().s[8]++;
    return customLinks.map(function (link) {
      cov_9w9avct5g().f[3]++;
      var linkTmp = (cov_9w9avct5g().s[9]++, _objectSpread({}, link));
      cov_9w9avct5g().s[10]++;
      linkTmp.name = (cov_9w9avct5g().b[2][0]++, linkTmp.rawName[language]) || (cov_9w9avct5g().b[2][1]++, linkTmp.rawName[defaultLanguage]) || (cov_9w9avct5g().b[2][2]++, (0, _values.default)(linkTmp.rawName)[0]);
      cov_9w9avct5g().s[11]++;
      linkTmp.url = (cov_9w9avct5g().b[3][0]++, linkTmp.rawUrl[language]) || (cov_9w9avct5g().b[3][1]++, linkTmp.rawUrl[defaultLanguage]) || (cov_9w9avct5g().b[3][2]++, (0, _values.default)(linkTmp.rawUrl)[0]);
      cov_9w9avct5g().s[12]++;
      return linkTmp;
    });
  }
});
var ConfigModel = (cov_9w9avct5g().s[13]++, {
  get: function get(data, oldState) {
    cov_9w9avct5g().f[4]++;
    var hostname = (cov_9w9avct5g().s[14]++, (cov_9w9avct5g().b[4][0]++, data) && (cov_9w9avct5g().b[4][1]++, data.hostname) || (cov_9w9avct5g().b[4][2]++, oldState) && (cov_9w9avct5g().b[4][3]++, oldState.hostname));
    var restHost = (cov_9w9avct5g().s[15]++, (cov_9w9avct5g().b[5][0]++, data) && (cov_9w9avct5g().b[5][1]++, data.restHost) || (cov_9w9avct5g().b[5][2]++, oldState) && (cov_9w9avct5g().b[5][3]++, oldState.restHost) || (cov_9w9avct5g().b[5][4]++, data) && (cov_9w9avct5g().b[5][5]++, "https://".concat(data.hostname, "/tnwr")));
    var apiKey = (cov_9w9avct5g().s[16]++, (cov_9w9avct5g().b[6][0]++, data) && (cov_9w9avct5g().b[6][1]++, data.apiKey) || (cov_9w9avct5g().b[6][2]++, oldState) && (cov_9w9avct5g().b[6][3]++, oldState.apiKey));
    var session = (cov_9w9avct5g().s[17]++, (cov_9w9avct5g().b[7][0]++, data) && (cov_9w9avct5g().b[7][1]++, data.session) || (cov_9w9avct5g().b[7][2]++, oldState) && (cov_9w9avct5g().b[7][3]++, oldState.session));
    // TODO : check with the backend for the next release, it should be either configuration, either config
    var configuration = (cov_9w9avct5g().s[18]++, (cov_9w9avct5g().b[8][0]++, data) && ((cov_9w9avct5g().b[8][1]++, data.configuration) || (cov_9w9avct5g().b[8][2]++, data.config)) || (cov_9w9avct5g().b[8][3]++, oldState) && (cov_9w9avct5g().b[8][4]++, oldState.configuration));

    // the default language is the one passed as parameter, or the one pas in the configuration (inside parameter)
    // or the previous state one
    var defaultLanguage = (cov_9w9avct5g().s[19]++, (cov_9w9avct5g().b[9][0]++, configuration) && (cov_9w9avct5g().b[9][1]++, configuration.institutionLanguage) || (cov_9w9avct5g().b[9][2]++, configuration) && (cov_9w9avct5g().b[9][3]++, configuration.institutionLanguage) || (cov_9w9avct5g().b[9][4]++, oldState.defaultLanguage) || (cov_9w9avct5g().b[9][5]++, 'en'));
    // To define the language we should display, first the language pass in params, or the previous language,
    // or the current language sent by the server or if none take the one from the institution
    var language = (cov_9w9avct5g().s[20]++, (cov_9w9avct5g().b[10][0]++, data) && (cov_9w9avct5g().b[10][1]++, data.language) || (cov_9w9avct5g().b[10][2]++, oldState) && (cov_9w9avct5g().b[10][3]++, oldState.language) || (cov_9w9avct5g().b[10][4]++, configuration) && (cov_9w9avct5g().b[10][5]++, configuration.currentLanguage) || (cov_9w9avct5g().b[10][6]++, configuration) && (cov_9w9avct5g().b[10][7]++, configuration.institutionLanguage));
    // Parse the customLinks with the language
    cov_9w9avct5g().s[21]++;
    if ((cov_9w9avct5g().b[12][0]++, configuration) && (cov_9w9avct5g().b[12][1]++, configuration.customLinks) && (cov_9w9avct5g().b[12][2]++, configuration.customLinks.length > 0)) {
      cov_9w9avct5g().b[11][0]++;
      cov_9w9avct5g().s[22]++;
      configuration.customLinks = LinkModel.get(configuration.customLinks, language, defaultLanguage);
    } else {
      cov_9w9avct5g().b[11][1]++;
    }
    var oldWidgetInfo = (cov_9w9avct5g().s[23]++, (cov_9w9avct5g().b[13][0]++, oldState) && (cov_9w9avct5g().b[13][1]++, oldState.widgetInfo));
    var widgetName = (cov_9w9avct5g().s[24]++, (cov_9w9avct5g().b[14][0]++, data) && (cov_9w9avct5g().b[14][1]++, data.widgetName) || (cov_9w9avct5g().b[14][2]++, oldWidgetInfo) && (cov_9w9avct5g().b[14][3]++, oldWidgetInfo.widgetName));
    var widgetBaseURL = (cov_9w9avct5g().s[25]++, (cov_9w9avct5g().b[15][0]++, data) && (cov_9w9avct5g().b[15][1]++, data.widgetBaseURL) || (cov_9w9avct5g().b[15][2]++, oldWidgetInfo) && (cov_9w9avct5g().b[15][3]++, oldWidgetInfo.widgetBaseURL));
    var widgetInfo = (cov_9w9avct5g().s[26]++, {
      widgetName: widgetName,
      widgetBaseURL: widgetBaseURL
    });
    var style = (cov_9w9avct5g().s[27]++, (cov_9w9avct5g().b[16][0]++, data) && (cov_9w9avct5g().b[16][1]++, data.style) || (cov_9w9avct5g().b[16][2]++, oldState) && (cov_9w9avct5g().b[16][3]++, oldState.style));
    var headers = (cov_9w9avct5g().s[28]++, _objectSpread(_objectSpread({}, data.standardHeaders), {}, {
      'Content-Type': 'application/json',
      'X-Secutix-Host': hostname,
      'X-API-Key': apiKey,
      'Accept-Language': language
    }));
    cov_9w9avct5g().s[29]++;
    if ((cov_9w9avct5g().b[18][0]++, session) && (cov_9w9avct5g().b[18][1]++, session.csrfToken)) {
      cov_9w9avct5g().b[17][0]++;
      cov_9w9avct5g().s[30]++;
      headers['X-CSRF-Token'] = session.csrfToken;
    } else {
      cov_9w9avct5g().b[17][1]++;
    }
    var currencyCode = (cov_9w9avct5g().s[31]++, (cov_9w9avct5g().b[19][0]++, configuration) && (cov_9w9avct5g().b[19][1]++, configuration.currencyCode) || (cov_9w9avct5g().b[19][2]++, oldState) && (cov_9w9avct5g().b[19][3]++, oldState.currencyCode));
    cov_9w9avct5g().s[32]++;
    return _objectSpread(_objectSpread({}, data), {}, {
      widgetInfo: widgetInfo,
      apiKey: apiKey,
      configuration: configuration,
      currencyCode: currencyCode,
      defaultLanguage: defaultLanguage,
      headers: headers,
      hostname: hostname,
      language: language,
      restHost: restHost,
      session: session,
      style: style
    });
  },
  refreshCsrfToken: function refreshCsrfToken(data, oldState) {
    cov_9w9avct5g().f[5]++;
    var session = (cov_9w9avct5g().s[33]++, (cov_9w9avct5g().b[20][0]++, oldState) && (cov_9w9avct5g().b[20][1]++, oldState.session));
    var token = (cov_9w9avct5g().s[34]++, (cov_9w9avct5g().b[21][0]++, data) && (cov_9w9avct5g().b[21][1]++, data.token) || (cov_9w9avct5g().b[21][2]++, session.csrfToken));
    var headers = (cov_9w9avct5g().s[35]++, (cov_9w9avct5g().b[22][0]++, oldState) && (cov_9w9avct5g().b[22][1]++, oldState.headers));
    cov_9w9avct5g().s[36]++;
    session.csrfToken = token;
    cov_9w9avct5g().s[37]++;
    if ((cov_9w9avct5g().b[24][0]++, headers) && (cov_9w9avct5g().b[24][1]++, token)) {
      cov_9w9avct5g().b[23][0]++;
      cov_9w9avct5g().s[38]++;
      headers['X-CSRF-Token'] = token;
    } else {
      cov_9w9avct5g().b[23][1]++;
    }
    cov_9w9avct5g().s[39]++;
    return _objectSpread(_objectSpread({}, oldState), {}, {
      headers: headers,
      session: session
    });
  },
  changeLanguage: function changeLanguage(config, language, defaultLanguage) {
    cov_9w9avct5g().f[6]++;
    var newConfig = (cov_9w9avct5g().s[40]++, _objectSpread({}, config));
    cov_9w9avct5g().s[41]++;
    if ((cov_9w9avct5g().b[26][0]++, newConfig.configuration) && (cov_9w9avct5g().b[26][1]++, newConfig.configuration.customLinks) && (cov_9w9avct5g().b[26][2]++, newConfig.configuration.customLinks.length > 0)) {
      cov_9w9avct5g().b[25][0]++;
      cov_9w9avct5g().s[42]++;
      newConfig.configuration.customLinks = LinkModel.changeLanguage(newConfig.configuration.customLinks, language, defaultLanguage);
    } else {
      cov_9w9avct5g().b[25][1]++;
    }
    cov_9w9avct5g().s[43]++;
    if (config.headers) {
      cov_9w9avct5g().b[27][0]++;
      cov_9w9avct5g().s[44]++;
      newConfig.headers = _objectSpread(_objectSpread({}, config.headers), {}, {
        'Accept-Language': language
      });
    } else {
      cov_9w9avct5g().b[27][1]++;
    }
    cov_9w9avct5g().s[45]++;
    return _objectSpread(_objectSpread({}, newConfig), {}, {
      defaultLanguage: defaultLanguage,
      language: language
    });
  }
});
var _default = exports.default = ConfigModel;